import React, { ChangeEvent, Component } from "react";
import "./ShippingZonesSidebar.scss";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetShippingZonesDTO from "../../../../models/DTO/IGetShippingZonesDTO";
import IOnGetShippingZonesDTO from "../../../../models/DTO/IOnGetShippingZonesDTO";
import IOnProcessShippingZonesDTO from "../../../../models/DTO/IOnProcessShippingZonesDTO";
import IProcessShippingZonesDTO from "../../../../models/DTO/IProcessShippingZonesDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INotification from "../../../../models/INotification";
import IShipping_ZoneUI from "../../../../models/IShipping_ZoneUI";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    createActive: boolean;
    shippingZones: IShipping_ZoneUI[];
    name: string;
};

class ShippingZonesSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            shippingZones: [],
            name: "",
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ShipmentOnGetShippingZones, this.onGetShippingZones);
        this.props.socket.on(EndpointsEnum.ShipmentOnProcessShippingZones, this.onProcessShippingZones);

        this.getShippingZones();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnGetShippingZones, this.onGetShippingZones);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnProcessShippingZones, this.onProcessShippingZones);
    }

    getShippingZones = () => {
        const payload: IGetShippingZonesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGetShippingZones, payload);
    };

    onGetShippingZones = (data: IOnGetShippingZonesDTO) => {
        this.setState({
            shippingZones: data.shippingZones,
        });
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        const payload: IProcessShippingZonesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shippingZones: [
                {
                    name: this.state.name,
                    is_default: false,
                    supplier_id: this.props.supplierModel.id,
                },
            ],
        };

        this.props.socket.emit(EndpointsEnum.ShipmentProcessShippingZones, payload);
    };

    onProcessShippingZones = (data: IOnProcessShippingZonesDTO) => {
        this.getShippingZones();
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    deleteZone = (zone: IShipping_ZoneUI) => {
        const payload: IProcessShippingZonesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shippingZones: [
                {
                    ...zone,
                    deleteFlag: true,
                },
            ],
        };

        this.props.socket.emit(EndpointsEnum.ShipmentProcessShippingZones, payload);
    };

    render() {
        return (
            <div className={"ShippingZonesSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-globe-americas"} title={"shipping_zones"} />
                    <hr />
                </div>

                <div className={"col-12"}>
                    <div className={"d-flex"}>
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} />
                        <div className={"ms-2"}>
                            <OwButton title={"create"} fn={this.create} />
                        </div>
                    </div>
                </div>

                <div className={"col-12 mt-4"}>
                    {this.state.shippingZones.map((zone) => {
                        return (
                            <div key={zone.guid}>
                                <i
                                    className={"fad fa-trash-alt text-danger me-2 pointer"}
                                    onClick={() => {
                                        this.deleteZone(zone);
                                    }}
                                />
                                {zone.name}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default ShippingZonesSidebar;
